import * as actionType from "../../actionType";

const initialState = {
  categoryDetails: '',
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.CATEGORY_DETAILS:
      return { ...state, categoryDetails: action.payload };
    default:
      return state;
  }
};

export default categoryReducer;
